/**
 * DIE ADRESSZEILE IN BUEHNENFENSTERN (Rafael, 03.10.2026: „Bühnenfenster
 * entschlacken: jedes Fenster hat oben drei Leisten (~100 px), und die
 * Adresszeile ist bei Berater-Seiten unnötig" — „Ja").
 *
 * Eine Buehnenkachel stapelte Buehnen-Kopfleiste, Reiter und die volle
 * Browser-Adresszeile. Bei einer Seite, die der Berater selbst auf diesem CUI
 * abgelegt hat (Entscheidungsgrundlage, Anleitung), traegt die Adresszeile
 * nichts bei: niemand tippt dort eine Adresse. Sie ist deshalb dort zu, und
 * ein Knopf im Reiter oeffnet sie. Fremde App-Adressen behalten sie — dort ist
 * sie das Werkzeug (Anmelden, Wechseln, Geraeteansicht).
 *
 * NUR IN BUEHNEN. Der Kontext unten wird ausschliesslich von
 * BuehnenArbeitsflaeche gesetzt; ein Browser-Panel im normalen Arbeitsbereich
 * sieht `false` und bleibt, wie es war.
 */
import { createContext } from 'react';

/** true = dieses Panel steht in einer Buehne (gesetzt von BuehnenArbeitsflaeche). */
export const BuehnenKontext = createContext(false);
/** Cancels account preparation when the stage changes, even with identical tile URLs. */
export const BuehnenKennungKontext = createContext<string | null>(null);

/** Fenster-Ereignis, mit dem der Reiter die Adresszeile eines Panels umschaltet. */
export const ADRESSZEILE_EREIGNIS = 'browser-adresszeile';
/** Fenster-Ereignis, mit dem der Reiter die aktuelle Seite eines Panels neu oeffnet (neuer Tab). */
export const OEFFNEN_EREIGNIS = 'browser-oeffnen';

const EIGENE_PFADE = ['/api/guide/', '/downloads/entscheidungen/'];

/**
 * Ist das eine Seite, die dieses CUI selbst ausliefert (Buehnen-/Guide-Seite,
 * Entscheidungsseite)? Relativ, gleicher Host oder gleicher Port wie das CUI
 * — UND ein Pfad, den nur das CUI kennt. Beides muss stimmen: eine fremde App
 * mit zufaellig gleichem Pfad behaelt ihre Adresszeile.
 *
 * Der Port-Vergleich deckt die Seiten ab, die der Server mit seiner
 * Tailscale-Adresse ablegt (`http://<ip>:<cui-port>/downloads/...`), waehrend
 * das CUI-Fenster unter einem anderen Namen fuer dieselbe Maschine laeuft.
 */
export function istEigeneCuiSeite(url: unknown): boolean {
  if (typeof url !== 'string' || !url.trim()) return false;
  const roh = url.trim();
  const relativ = roh.startsWith('/') && !roh.startsWith('//');
  let u: URL;
  try { u = new URL(roh, window.location.origin); } catch { return false; }
  if (!EIGENE_PFADE.some(p => u.pathname.startsWith(p))) return false;
  if (relativ || u.host === window.location.host) return true;
  return u.port !== '' && u.port === window.location.port;
}
